<template>
  <div class="modules">
    <el-row class="card-list" :gutter="getHideApproval ? 15 : 0">
      <el-col :span="8" v-for="module in getModules" :key="module.id">
        <card :card-title="module.name" :title-image="module.iconName" :show-gap="getHideApproval" :shadow="getHideApproval ? 'always' : 'hover'" style="height: 170px;" :has-permission="module.hasPermission">
          <div class="tabs">
            <div class="tab-item" :class="{ 'disabled': !tabItem.count || tabItem.count == 0, 'no-permission': !module.hasPermission}"  v-for="(tabItem, tabIndex) in module.tabs" :key="tabIndex" @click="toPage(tabItem, module)">
              <p class="count">{{ tabItem.count || 0 }}</p>
              <p class="tab-name">{{ $t(tabItem.statusText) }}</p>
            </div>
          </div>
        </card>
      </el-col>
    </el-row>
    <card class="more" :style="{ 'margin-left': getHideApproval ? '15px' : '0' }" :body-style="bodyStyle" :show-gap="getHideApproval" :shadow="getHideApproval ? 'always' : 'hover'" @click="handleViewMore">
      <i class="icon el-icon-s-grid"></i>
      <span class="text">{{$t('homepage.txt014')}}</span>
    </card>

    <bsp-dialog :title="$t('homepage.txt012')" :dialog-visible.sync="visible" @closeButton="handleClose" class="dialog-card" width="900px">
      <template #body>
        <el-row class="dialog-card-list card-list" :gutter="15">
          <el-col :span="12" v-for="module in moduleList" :key="module.id">
            <card :card-title="module.name" :title-image="module.iconName" :has-permission="module.hasPermission">
              <div class="tabs">
                <div class="tab-item" :class="{ 'disabled': !tabItem.count || tabItem.count == 0, 'no-permission': !module.hasPermission}" v-for="(tabItem, tabIndex) in module.tabs" :key="tabIndex" @click="toPage(tabItem, module)">
                  <p class="count">{{ tabItem.count || 0 }}</p>
                  <p class="tab-name">{{ $t(tabItem.statusText) }}</p>
                </div>
              </div>
            </card>
          </el-col>
        </el-row>
      </template>
      <template #footer>
        <el-button size="medium" @click="visible = false">{{$t('homepage.txt013')}}</el-button>
      </template>
    </bsp-dialog>
  </div>
</template>

<script>
  import Card from './Card'
  import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
  export default {
    name: "RoleFunctions",
    components: {
      Card,
      BspDialog
    },
    props: {
      hideApproval: {
        type: Boolean,
        default: false
      },
      moduleList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        bodyStyle: {
          'display': 'flex',
          'flex-direction': 'column',
          'align-items': 'center',
          'justify-content': 'center'
        },
        visible: false
      }
    },
    methods: {
      handleViewMore() {
        this.visible = true
      },
      handleClose() {
        this.visible = false
      },
      toPage(val, module) {
        if(module && !module.hasPermission){
          return;
        }
        this.$emit('to',val)
      }
    },
    computed: {
      getModules() {
        return this.moduleList.slice(0, 3)
      },
      getHideApproval() {
        return this.hideApproval
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modules {
    display: flex;
    justify-content: center;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    -moz-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    overflow: hidden;
  }
  .card-list {
    flex: 1;
  }
  .dialog-card-list {
    padding: 0 8px;
    .card {
      margin-top: 8px;
      margin-bottom: 8px;
    };
  }
  .more {
    cursor: pointer;
    width: 70px;
    color: #C73122;
    .icon {
      font-size: 30px;
      margin-left: 0;
    }
    .text {
      font-size: 12px;
      line-height: 22px;
      height: 22px;
      margin-top: 5px;
    }
  }
  .tabs {
    display: flex;
    padding: 15px 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    .tab-item {
      line-height: 1;
      /*font-size: 12px;*/
      flex: 1;
      text-align: center;
      cursor: pointer;
      &.disabled {
        color: #999;
        //cursor: initial;
      }
      &.no-permission {
        color: #999;
        cursor: no-drop;
      }
      &:not(.no-permission):hover {
        color: #C73122;
      }
      .count {
        font-size: 30px;
        margin-bottom: 12px;
      }
      .tab-name {}
    }
  }
</style>
